export default function NumberBalls({
  numbers,
  className = '',
}: {
  numbers?: number[]
  className?: string
}) {
  return (
    <div
      className={`md-balls ${className}`}
      aria-label={numbers?.length ? `번호 ${numbers.join(', ')}` : '번호 대기 중'}
    >
      {Array.from({ length: 6 }, (_, index) => {
        const number = numbers?.[index]
        return (
          <span
            key={index}
            aria-hidden="true"
            className={`md-ball ${number ? `md-ball-${Math.min(5, Math.ceil(number / 10))}` : 'md-ball-empty'}`}
          >
            {number ?? '—'}
          </span>
        )
      })}
    </div>
  )
}
